import React, { useState } from 'react';
import { Modal } from 'antd';
import * as Yup from 'yup';
import {
  dadosGeraisState,
  desabilitarAcoesState,
  ordemCompraIdState,
  reloadState,
} from '../atoms';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  Button,
  FormSubmitButton,
  FormTextArea,
  MasterDetailForm,
} from '@digital/ui';
import { cancelar } from '@app/api/sas/ordemCompra';
import { Visibility, UploadFile } from '@app/components';

const ButtonModalCancelarOc = () => {
  const [enviarEmail , setEnviarEmail] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useRecoilState(reloadState);
  const ordemCompraId = useRecoilValue(ordemCompraIdState);
  const dadosGerais = useRecoilValue(dadosGeraisState);
  const desabilitarAcoes = useRecoilValue(desabilitarAcoesState);
  const [arquivoSelecionado, setArquivoSelecionado] = useState(null);


  const handleCancel = () => {
    setShowModal(false);
    setArquivoSelecionado(null);
  };


  const handleSubmit = async (values) => {
  const enviar = await new Promise((resolve) => {
    Modal.confirm({
      title: 'Confirmação Envio de Email',
      content: 'Você deseja enviar este e-mail?',
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });

  cancelar(ordemCompraId, values.justificativaCancelamento, arquivoSelecionado, enviar).then((data) => {
    if (data) {
      setReload(!reload);
      handleCancel();
    }
  });
};


  const handleFileChange = function (event) {
    const file = event.file; 
    if (file) {
        console.log('Arquivo selecionado:', file.name);
        setArquivoSelecionado(file);
    }
  };

  const renderFooter = () => {
    const botoes = [];

    botoes.push(
      <Button
        key="fechar"
        title="Fechar"
        type="link"
        onClick={handleCancel}
      />
    );

    if (!desabilitarAcoes) {
      botoes.push(
        <FormSubmitButton
          key="enviar"
          noIcon
          title="Enviar"
          type="success"
        />
      );
    }

    return botoes;
  };

  
  const titleConsultiva = dadosGerais.consultiva ? "CANCELAR CONSULTIVA" : "CANCELAR OC"; 

  return (
    <>
      <Button title={titleConsultiva} type="danger" onClick={() => setShowModal(true)} />
      <Visibility visible={showModal}>
        <MasterDetailForm
          key={`formCancelarOc_${ordemCompraId}`}
          onSubmit={handleSubmit}
          initialValues={dadosGerais}
        >
          <Modal
            title="Cancelar OC"
            visible={showModal}
            onCancel={handleCancel}
            footer={renderFooter()}
          >
            <FormTextArea
              label="Justificativa"
              name="justificativaCancelamento"
              rows={6}
              span={12}
              required
              disabled={desabilitarAcoes}
              validateSchema={Yup.string().trim().required('Campo requerido.')
                .max(2000, 'A justificativa deve ter no máximo 2000 caracteres.')}
            />

            <UploadFile
              idDoComponente="sgc-upload-single-ModalInclusaoMultAnexo"
              nameFormData="arquivo"
              label="Adicionar arquivo"
              type="primary"
              hasFile={!!arquivoSelecionado}
              disabled={desabilitarAcoes}
              span={7}
              onChange={handleFileChange}
            />
          </Modal>
        </MasterDetailForm>
      </Visibility>
    </>
  );
};

export default ButtonModalCancelarOc;
